import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { ThemeBlueprint } from '@backstage/plugin-app-react';
import { UnifiedThemeProvider } from '@backstage/theme';
import Brightness4Icon from '@material-ui/icons/Brightness4';
import Brightness7Icon from '@material-ui/icons/Brightness7';
import { koviDarkTheme, koviTheme } from './koviTheme';

const lightTheme = ThemeBlueprint.make({
  name: 'light',
  params: {
    theme: {
      id: 'light',
      title: 'Claro',
      variant: 'light',
      icon: <Brightness7Icon />,
      Provider: ({ children }) => (
        <UnifiedThemeProvider theme={koviTheme} children={children} />
      ),
    },
  },
});

const darkTheme = ThemeBlueprint.make({
  name: 'dark',
  params: {
    theme: {
      id: 'dark',
      title: 'Escuro',
      variant: 'dark',
      icon: <Brightness4Icon />,
      Provider: ({ children }) => (
        <UnifiedThemeProvider theme={koviDarkTheme} children={children} />
      ),
    },
  },
});

export const themeModule = createFrontendModule({
  pluginId: 'app',
  extensions: [lightTheme, darkTheme],
});
